import userServiceObj from "ApiService/userService";
import { create } from "zustand";

const userStore = (set: any) => ({
  currentUser: {},
  isLoading: false,
  getCurrentUser: async () => {
    try {
      set(() => ({ isLoading: true }));
      const { data }: any = await userServiceObj.currentUser({});
      set(() => ({ currentUser: data, isLoading: false }));
    } catch (err) {
      console.error(err);
      set(() => ({ isLoading: false }));
      throw err;
    }
  },
  setLoading: (loading: boolean) =>
    set((state: any) => ({
      isLoading: loading,
    })),
  setCurrentUser: (userDetails: any) =>
    set((state: any) => ({
      currentUser: userDetails,
    })),
});

const useUserStore = create(userStore);

export default useUserStore;
